import { Directive, HostListener, Input, ElementRef, OnInit, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Permission, Role, isAllowed } from './permissions';
import { PermissionDeniedDialogComponent } from './permission-denied-dialog.component';

@Directive({ selector: '[appGuardCtaByPermission]' })
export class GuardCtaByPermissionDirective implements OnInit, OnDestroy {
  @Input('appGuardCtaByPermission') permission!: Permission;
  @Input('appGuardCtaByPermissionRole') role?: Role;

  private captureListener?: EventListener;

  constructor(private dialog: MatDialog, private host: ElementRef<HTMLElement>) {}

  ngOnInit(): void {
    // Add capturing-phase listener to guarantee we intercept before template (bubble) handlers
    this.captureListener = (ev: Event) => {
      if (!this.permission) { return; }
      const role = this.role ?? this.readRole();
      if (!isAllowed(role, this.permission)) {
        ev.preventDefault();
        if ((ev as any).stopImmediatePropagation) {
          (ev as any).stopImmediatePropagation();
        }
        ev.stopPropagation();
        this.openDeniedDialog();
      }
    };
    this.host.nativeElement.addEventListener('click', this.captureListener, { capture: true });
  }

  ngOnDestroy(): void {
    if (this.captureListener) {
      this.host.nativeElement.removeEventListener('click', this.captureListener, { capture: true } as any);
      this.captureListener = undefined;
    }
  }

  @HostListener('click', ['$event'])
  onClick(ev: Event) {
    if (!this.permission) { return; }
    const role = this.role ?? this.readRole();
    if (!isAllowed(role, this.permission)) {
      ev.preventDefault();
      if ((ev as any).stopImmediatePropagation) {
        (ev as any).stopImmediatePropagation();
      }
      ev.stopPropagation();
      this.openDeniedDialog();
    }
  }

  private readRole(): Role | null {
    try {
      const loginAs = localStorage.getItem('loginAs') || sessionStorage.getItem('loginAs');
      if (!loginAs) return null;
      return loginAs.trim() as Role;
    } catch { return null; }
  }

  private openDeniedDialog(): void {
    this.dialog.open(PermissionDeniedDialogComponent, { width: '400px' });
  }
}


